// extracted by mini-css-extract-plugin
module.exports = {"page__content":"Page-module--page__content--3kTnt","page__title":"Page-module--page__title--lrN8Z"};